/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Communication method
 */
export enum CommunicationMethod {
    TELEGRAM = 'Telegram',
    WHATS_APP = 'WhatsApp',
    EMAIL = 'Email',
}
